import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCc7JNxnuY7AA2CabSBzuacEpUJIC95eaE",
  authDomain: "obinns-happily-ever-after.firebaseapp.com",
  projectId: "obinns-happily-ever-after",
  storageBucket: "obinns-happily-ever-after-photos.firebasestorage.app",
  messagingSenderId: "253987264274",
  appId: "1:253987264274:web:17942d505a815557d085cb"
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app, "rsvp");
const functions = getFunctions(app);

if (window.location.hostname === "localhost") {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFunctionsEmulator(functions, "localhost", 5001);
  connectFirestoreEmulator(db, "localhost", 8080);
}

export { app, auth, db, functions };
